import { ActiveUtterancesContext } from "@/providers/ScrollManagerContext/ActiveUtterancesContext";
import { ScrollManagerContext } from "@/providers/ScrollManagerContext/ScrollManagerProvider";
import { useContext } from "react";

export const useScrollManager = () => useContext(ScrollManagerContext);

export const useActiveUtterances = () => useContext(ActiveUtterancesContext);
